<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    [hasDetailView]="true">
</acabim-datatable>

<p-footer class="cas-action-buttons">
    <button type='button' class="cas-button-action" (click)="onAddSiteGroup()">Add site group</button>
</p-footer>
<acabim-modal
        [display]="addSiteGroupModal"
        [title]="'Add project group details'"
        (status)="setAddSiteGroupModal($event)"
        [footer]="false"
        width="70vw"
>
    <acabim-admin-groups-site-add
            actionType="add"
            actionButtonLabel="Add"
            (completed)="onAddCompletion($event)">
    </acabim-admin-groups-site-add>
</acabim-modal>

<ng-template [ngIf]="dataSources[0].showDetails">
    <acabim-modal
            [display]="true"
            [title]="'Edit project group details'"
            (status)="setEditSiteGroupModal($event)"
            [footer]="false"
            width="70vw"
    >
        <acabim-admin-groups-site-update
                [siteDetails]="dataSources[0].detailData"
                (completed)="onEditCompletion($event)">
        </acabim-admin-groups-site-update>
    </acabim-modal>
</ng-template>
